// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"ef4688e8","87":"dda8d2b3","356":"11a12092","472":"1b955c0f","526":"55932dc3","803":"2657620a","848":"b4e675b2","928":"3fa7239c","998":"7c887e30"}[chunkId] + ".chunk.js";
};